export const convertList = (list) => list

export const convertListLog = (listLog) => listLog
